import { FormikValues, getIn, setIn } from 'formik';
import { Geocoding } from 'shared/geo/GeoHelpers';
import { joinStrings } from 'shared/utils/StringUtils';

export function applyGeocodedVenue(
  values: FormikValues,
  name: string,
  geocoding: Geocoding,
): FormikValues {
  return setIn(values, name, {
    ...getIn(values, name),
    city: geocoding.place || '',
    zip: geocoding.postcode || '',
    state: geocoding.region_short || geocoding.region || '',
    address: joinStrings(' ', geocoding.house_number, geocoding.address),
  }) as FormikValues;
}
